$(function() {
    const formWrapper = document.getElementById('home-properties-search');
    if (!formWrapper) return;
    const form = formWrapper.querySelector('form');
    const min_price = form.querySelector('#min_price');
    const max_price = form.querySelector('#max_price');

    [...formWrapper.querySelectorAll('input[type="radio"]')].forEach((rad, i) => {
        rad.addEventListener('change', ev => {
            // Set form action to point to the correct page
            form.setAttribute('action', `/properties/${buy_rent()}/${res_comm()}`);
            if (i >= 2) return; // Don't need to adjust prices for property type changes
            // Remove all the options in the select
            while (min_price.firstChild) min_price.removeChild(min_price.firstChild);
            while (max_price.firstChild) max_price.removeChild(max_price.firstChild);
            // Create default options
            min_price.appendChild(createOption('No Minimum Price', '0'));
            max_price.appendChild(createOption('No Price Limit', '0'));
            // Iterate over values appending options to the select
            const divisor = buy_rent() === 'buy' ? [1, 1] : [250, 1000];
            const suffix = buy_rent() === 'buy' ? '' : ' per week'
            for (let i = 5e4 / divisor[0]; i <= 2e6 / divisor[1]; i += 5e4 / divisor[0]) {
                min_price.appendChild(createOption(`$${i.toLocaleString(undefined)}${suffix}`, i));
                max_price.appendChild(createOption(`$${i.toLocaleString(undefined)}${suffix}`, i));
            }
        })
    });

    const buy_rent = () => __find_checked('buy_rent').getAttribute('value');
    const res_comm = () => __find_checked('res_comm').getAttribute('value');
    const __find_checked = name => [...formWrapper.querySelectorAll(`input[name="${name}"]`)].find(rad => rad.checked);
});

function createOption(text, value) {
    const option = document.createElement('option');
    option.setAttribute('value', value);
    option.innerHTML = text;
    return option;
}
